import { PictogramsApi } from '../../api';
import axios from '../axios';

const pictogramsApi = new PictogramsApi(undefined, undefined, axios);

export default pictogramsApi;
